export const iframeStyleTag = `
  body {
    margin: 0;
    margin-top: -2.5rem;
  }

  a {
    pointer-events: none;
  }

  * {
    scrollbar-color: #c9d2e8 transparent;
    scrollbar-width: thin;
  }

  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    background-color: transparent;
  }

  ::-webkit-scrollbar-thumb {
    height: 6px;
    border: 2px solid transparent;
    background-color: #c9d2e8;
    background-clip: padding-box;
    border-radius: 8px;
  }
  ::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }
  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }
`;
